import { CalendarCheckIcon, LockIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { ReservationStatus } from '@/api/reservations/get-reservation-dashboard'
import { Badge } from '@/components/ui/badge'
import { Chip } from '@/components/ui/chip'
import { Typography } from '@/components/ui/typography'
import {
  getStatusLabel,
  STATUS_COLOR_MAP,
} from '@/pages/reservations/reservations-dashboard/reservations-dashboard.constants'

interface Props {
  type: string
  amenityName: string
  locationName: string
  timeBlockReason?: string
  resident?: { firstName: string; lastName: string; unit: string }
  status?: ReservationStatus
}

export const AgendaReservationTimeBlockItem = ({
  type,
  amenityName,
  locationName,
  resident,
  timeBlockReason,
  status,
}: Props) => {
  const { t } = useTranslation(['reservations'])

  let mainText = ''
  let subText = ''

  if (type === 'timeBlock') {
    mainText = `${timeBlockReason}`
    subText = `${amenityName} ${locationName ? `/ ${locationName}` : ''}`
  } else if (type === 'reservation') {
    mainText = `${amenityName} ${locationName ? `/ ${locationName}` : ''}`
    subText = `${resident?.firstName} ${resident?.lastName}${resident?.unit ? `, ${resident?.unit}` : ''}`
  }

  return (
    <div className={`ctp-agenda-event agenda-reservation-item ${type}`}>
      <div className={`reservation-item__icon ${type}`}>
        {type === 'timeBlock' ? <LockIcon /> : <CalendarCheckIcon />}
      </div>
      <Typography as="span" size="heading-tiny" color="black800">
        {mainText}
      </Typography>
      <Typography as="span" size="heading-tiny" color="black800" weight="light">
        -
      </Typography>
      <Typography as="span" size="heading-tiny" color="black800" weight="light">
        {subText}
      </Typography>
      {type === 'timeBlock' && (
        <div className="agenda-reservation-item__chip">
          <Chip label={'Time Block'} color="orange" size="small" variant="light" />
        </div>
      )}
      {status && (
        <div className="agenda-reservation-item__chip">
          <Badge color={STATUS_COLOR_MAP[status]} size="small" variant="light">
            {getStatusLabel(t, status)}
          </Badge>
        </div>
      )}
    </div>
  )
}
